export default __webpack_public_path__ + "static/media/nutrition.107974b5.png";